import { get, post, put, deleted } from '..';
import routes from './routes';

const SectionServices = {
  createSection: async (obj) => {
    const data = await post(routes.createSection, obj);
    return data;
  },
  getSections: async (params) => {
    const data = await get(routes.getSections, params);
    return data;
  },
  getSectionById: async (id) => {
    const data = await get(routes.getSectionById + id);
    return data;
  },
  updateSection: async (id, obj) => {
    const data = await put(routes.updateSection + id, obj);
    return data;
  },
  deleteSection: async (id) => {
    const data = await deleted(routes.deleteSection + id);
    return data;
  },
}

export default SectionServices